export default __webpack_public_path__ + "static/media/Blog5.7c4d269a.png";